import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sideBar-index" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": _ctx.activeRouter,
      router: "true",
      class: "el-menu-vertical-demo",
      "text-color": "#666666",
      "active-text-color": "#191C29"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/mineSubject" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("我的课程", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/shoppingCart" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("购物车", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/mineOrder" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("我的订单", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}